<footer class="footer">
    <div class="wrapper-md">
        <div class="logo" [class.logo-en]="isEn"></div>
        <div class="text" *ngIf="text" [innerHTML]="text | safeHtml"></div>
    </div>
</footer>
